import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { featureFlags } from 'common/featureFlags/featureFlags';
import type { ComponentWithoutHOCProps } from 'common/types/component';

import { withAuthLayout } from '../login/withAuthLayout';

const _OktaPostLogoutCallback = (): ReactElement => {
    const switchUserReturnUrl = localStorage.getItem('postLoginRedirectUrl');
    if (featureFlags.fxIntegration && switchUserReturnUrl) {
        localStorage.removeItem('postLoginRedirectUrl');

        return <Navigate to={switchUserReturnUrl} replace />;
    }

    return <Navigate to="/" replace />;
};

const OktaPostLogoutCallback: ComponentWithoutHOCProps<null> = withAuthLayout(_OktaPostLogoutCallback);
export default OktaPostLogoutCallback;
